import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Stack from "@mui/material/Stack";
import { CreditCard as CreditCardIcon } from "@phosphor-icons/react/dist/ssr/CreditCard";
import { FC } from "react";
import { TrialRemainingCard } from "~ui-components/index";
import { dayjs } from "~ui-components/libs/dayjs";
import { Account } from "~ui-components/types/__generated/gql/graphql";
import {
	Summary,
	usePlanSummary,
	USERS_SUMMARY,
} from "../subscription-summary";

export const PaidTrialUserAccount: FC<{ account: Account }> = ({ account }) => {
	const planSummary = usePlanSummary();
	const total = 30;
	const remainingDays = dayjs(account.subscription.trialExpiresAt).diff(
		dayjs(),
		"day",
	);

	const cardContent = {
		title: `You're trialing new features`,
		content: `You're currently enjoying an upgrade trial. Your account will be automatically billed at you new plan settings when trial period expires.`,
	};

	return (
		<Card>
			<CardHeader
				avatar={
					<Avatar>
						<CreditCardIcon fontSize="var(--Icon-fontSize)" />
					</Avatar>
				}
				title="Subscription Summary"
			/>
			<CardContent>
				<Stack
					direction={{ xs: "column", sm: "row" }}
					spacing={3}>
					<Stack
						spacing={3}
						sx={{
							flex: "0 0 auto",
							justifyContent: "space-between",
							width: "100%",
						}}>
						<TrialRemainingCard
							remainingDays={remainingDays}
							total={total}
							title={cardContent.title}
							content={cardContent.content}
							isPaidTrial
						/>
						<Summary items={planSummary} />
						<Summary items={USERS_SUMMARY} />
					</Stack>
				</Stack>
			</CardContent>
		</Card>
	);
};
